<template>
    <div
        :class="{ 'l-ss-c-filter-is-short': isShort }"
        class="l-ss-c-filter-range">
        <c-label
            v-if="showTitle"
            :label="filterLabel"/>
        <div class="l-ss-c-filters-filter-range-ranges">
            <div
                class="l-ss-c-filters-filter-range-input-wrapper">
                <input
                    v-model="minValue"
                    :placeholder="placeholderMinValue"
                    class="l-ss-c-input l-ss-c-filters-filter-range-range-input"
                    type="tel"
                    :maxlength="String(filter.maxValue).length + 2"
                    autofocus
                    @focus="onInputFocus"
                    @input="onMinInput"
                    @keydown="onMinInput">
            </div>
            <div>-</div>
            <div
                class="l-ss-c-filters-filter-range-input-wrapper">
                <input
                    v-model="maxValue"
                    :placeholder="placeholderMaxValue"
                    class="l-ss-c-input l-ss-c-filters-filter-range-range-input"
                    type="tel"
                    :maxlength="String(filter.maxValue).length + 2"
                    @focus="onInputFocus"
                    @input="onMaxInput"
                    @blur="onMaxInputBlur"
                    @keydown="onMaxInput">
            </div>
        </div>
        <div class="l-ss-c-filter-range-presets">
            <button
                v-for="preset in presets"
                :key="`filter-${filter.name}-preset-${preset.maxValue}`"
                class="l-ss-c-filter-range-presets-item"
                :class="{ 'l-ss-c-filter-range-presets-item-active': preset.active }"
                @click="() => setPreset(preset)">
                {{ preset.label }}
            </button>
        </div>
    </div>
</template>

<script>
    import FilterMixin from './mixin';
    import CLabel from './components/label';
    import { baseCurrency } from '../../../../helpers/display';

    const RANGE_CHANGE_DELAY = 800;
    const STEP_LENGTH = 2;
    const BACKSPACE_KEY_CODE = 8;
    const getPlaceholder = (value, symbol) => `${value} ${symbol}`;
    export default {
        components: {
            CLabel,
        },
        mixins: [
            FilterMixin,
        ],
        data() {
            return {
                minValue: '',
                maxValue: '',
                oldMinValue: '',
                newMinValue: null,
                newMaxValue: null,
            };
        },
        computed: {
            name() {
                return `${this.filter.name}`;
            },
            placeholderMinValue() {
                return getPlaceholder(this.filter.minValue, this.symbol);
            },
            placeholderMaxValue() {
                return getPlaceholder(this.filter.maxValue, this.symbol);
            },
            presets() {
                const round = value => {
                    const str = String(value);
                    const len = str.length;
                    const num = Number(str[0]) + 1;
                    const numbers = new Array(len - 1).fill(0).join('');
                    const maxValue = parseInt(`${num}${numbers}`);
                    return Math.round(value / maxValue) * maxValue;
                };
                // Todo тут тупой код, как-то сразу в голову не пришло
                if (!this.filter.preset) {
                    const filterMax = this.filter.maxValue;
                    const filterMin = Number(this.filter.minValue || 0) || 0;
                    const roundedMax = round(filterMax);
                    const roundedMin = round(filterMin);
                    const step = Math.floor((roundedMax - roundedMin) / STEP_LENGTH);
                    let prev = filterMin;
                    const formatLabel = value => baseCurrency(value);

                    let items = new Array(STEP_LENGTH)
                        .fill(0)
                        .map((i, j) => {
                            const fromValue = prev;
                            let toValue = fromValue + step;
                            if (j === 0) {
                                toValue = step;
                                if (step < filterMin) {
                                    toValue = filterMin + step;
                                }
                            }
                            if (j === STEP_LENGTH - 1) {
                                toValue = filterMax;
                            }
                            if (toValue >= filterMax) {
                                toValue = filterMax;
                            }
                            prev = toValue;
                            return `${fromValue}-${toValue}`;
                        });

                    // TODO
                    items = Array.from(new Set(items)).map((item) => {
                        const [fromValue, toValue] = item.split('-').map(value => +value);
                        return {
                            label: `${formatLabel(fromValue)} ${this.symbol} — ${formatLabel(toValue)} ${this.symbol}`,
                            minValue: fromValue,
                            maxValue: toValue,
                            active: +this.currencyRemove(this.minValue, this.symbol) === fromValue && +this.currencyRemove(this.maxValue, this.symbol) === toValue,
                        };
                    });

                    /*
                     * Todo unexpected popup closing
                     * if (this.minValue || this.maxValue) {
                     */
                    items.splice(0, 0, {
                        label: this.$t('filters.rangeShowAll'),
                        minValue: '',
                        maxValue: '',
                        active: !this.minValue && !this.maxValue,
                    });
                    // }

                    return items;
                }

                return this.filter.preset || [];
            },
        },
        watch: {
            filterValue: {
                handler(value) {
                    if (value) {
                        if (value.min) {
                            this.minValue = this.addCurrency(value.min, this.symbol);
                        }
                        if (value.max) {
                            this.maxValue = this.addCurrency(value.max, this.symbol);
                        }
                    } else {
                        this.minValue = '';
                        this.maxValue = '';
                    }
                },
                immediate: true,
            },
        },

        beforeDestroy() {
            clearTimeout(this.emitTimer);
        },
        methods: {
            onMinInput(event) {
                let value = event.target.value;
                value = value === '' ? '' : value;

                this.newMinValue = this.currencyRemove(value, this.symbol).replace(/[^\d]/g,'');
                if (event.keyCode === BACKSPACE_KEY_CODE && this.newMinValue !== '') {
                    const arr = this.newMinValue.split('');
                    this.newMinValue = arr.slice(0, this.newMinValue.length - 1).join(',');
                }
                if (this.currencyRemove(this.newMinValue, this.symbol) === '') {
                    this.newMinValue = '';
                }
                this.minValue = this.addCurrency(this.newMinValue, this.symbol);
                this.runEmitRangeChange();
            },
            onMaxInput(event) {
                let value = event.target.value;
                value = value === '' ? '' : value;
                this.newMaxValue = this.currencyRemove(value, this.symbol).replace(/[^\d]/g,'');

                if (event.keyCode === BACKSPACE_KEY_CODE && this.newMaxValue !== '') {
                    const arr = this.newMaxValue.split('');
                    this.newMaxValue = arr.slice(0, this.newMaxValue.length - 1).join(',');
                }
                if (this.currencyRemove(this.newMaxValue, this.symbol) === '') {
                    this.newMaxValue = '';
                }
                this.maxValue = this.addCurrency(this.newMaxValue, this.symbol);
                this.runEmitRangeChange();
            },
            runEmitRangeChange() {
                if (this.emitTimer) {
                    clearTimeout(this.emitTimer);
                }
                this.emitTimer = setTimeout(() => {
                    const { minValue, maxValue } = this;
                    const formatMinValue = +this.currencyRemove(minValue, this.symbol);
                    const formatMaxValue = +this.currencyRemove(maxValue, this.symbol);
                    const range = {};
                    if (minValue !== '' && !isNaN(formatMinValue)) {
                        range.min = formatMinValue !== 0 ? formatMinValue : undefined;
                    }
                    if (maxValue !== '' && !isNaN(formatMaxValue)) {
                        range.max = formatMaxValue !== 0 ? formatMaxValue : undefined;
                    }
                    if (range.max !== undefined || range.min !== undefined) {
                        range.condition = 'range';
                        this.onChange(range);
                    } else {
                        this.onChange();
                    }
                }, RANGE_CHANGE_DELAY);
            },
            onInputFocus() {
                clearTimeout(this.emitTimer);
            },
            onMaxInputBlur() {
                this.$nextTick(() => {
                    if (this.maxValue) {
                        this.$emit('ready');
                    }
                });
            },
            setPreset(preset) {
                this.minValue = this.addCurrency(String(preset.minValue), this.symbol);
                this.maxValue = this.addCurrency(String(preset.maxValue), this.symbol);
                this.runEmitRangeChange();
            },
            currencyRemove(value, currency) {
                if (currency) {
                    value = value.replaceAll(currency, '');
                }
                return value.trim().replaceAll(' ', '');
            },
            addCurrency(value, currency) {
                return (value.trim() + ` ${currency}`).trim();
            },
        },
    };
</script>